const Menu = [
  { path: "/", label: "Página Inícial" },
  { path: "/sobre", label: "Sobre Nós" },
  { path: "/noticias", label: "Notícias" },
  { path: "/areas-pratica", label: "Áreas de Prática" },
  { path: "/contactos", label: "Contactos" },
  { path: "/candidaturas", label: "Candidaturas" },
];

export default Menu;